const $body = document.querySelector("body");
const $container = document.querySelector(".site-container");

const shortContent = () => {
    $body.classList.remove("shortContent");
    if (window.innerHeight > $container.offsetHeight) {
        $body.classList.add("shortContent");
    }
};

shortContent();
window.addEventListener("resize", shortContent);
